import { render, staticRenderFns } from "./confirmation-code-page.vue?vue&type=template&id=47d2ae6e&scoped=true"
import script from "./confirmation-code-page.vue?vue&type=script&lang=js"
export * from "./confirmation-code-page.vue?vue&type=script&lang=js"
import style0 from "./confirmation-code-page.vue?vue&type=style&index=0&id=47d2ae6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2ae6e",
  null
  
)

export default component.exports